import React from "react";

export const AuthenticationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0013 11.9993H14.0013V3.99935H2.0013V11.9993ZM0.667969 3.33268C0.667969 2.9645 0.966449 2.66602 1.33464 2.66602H14.668C15.0362 2.66602 15.3346 2.9645 15.3346 3.33268V12.666C15.3346 13.0342 15.0362 13.3327 14.668 13.3327H1.33464C0.966449 13.3327 0.667969 13.0342 0.667969 12.666V3.33268ZM6.0013 6.66602C6.0013 6.29783 5.70282 5.99935 5.33464 5.99935C4.96645 5.99935 4.66797 6.29783 4.66797 6.66602C4.66797 7.03422 4.96645 7.33268 5.33464 7.33268C5.70282 7.33268 6.0013 7.03422 6.0013 6.66602ZM7.33464 6.66602C7.33464 7.77062 6.4392 8.66602 5.33464 8.66602C4.23007 8.66602 3.33464 7.77062 3.33464 6.66602C3.33464 5.56145 4.23007 4.66602 5.33464 4.66602C6.4392 4.66602 7.33464 5.56145 7.33464 6.66602ZM5.33584 10.666C4.69132 10.666 4.1089 10.9265 3.68592 11.3494L2.74312 10.4066C3.40592 9.74382 4.3235 9.33268 5.33584 9.33268C6.34818 9.33268 7.26577 9.74382 7.92857 10.4066L6.98577 11.3494C6.56278 10.9265 5.98036 10.666 5.33584 10.666ZM10.806 9.80408L13.4727 7.13742L12.5299 6.19461L10.3346 8.38988L9.13937 7.19462L8.19657 8.13742L9.86324 9.80408L10.3346 10.2755L10.806 9.80408Z"
        fill="currentColor"
      />
    </svg>
  );
};
